<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Auditor', apiMethod: 'Auditors', form: () => import('../forms/AuditorForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Auditor Member', apiMethod: 'AuditorMembers', parentForeignKey: 'auditorId', form: () => import('../forms/AuditorMemberForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Audits', value: 'auditorId', table: () => import('../tables/AuditsTable') },
                    { text: 'Members', value: 'auditorId', isCard: true, table: () => import('../tables/AuditorMembersTable') },
                    { text: 'Users', value: 'auditorId', table: () => import('../tables/UsersTable') },
                ],
                mainForm: () => import('../forms/AuditorForm'),
                claimName: 'Auditors',
                apiMethod: 'Auditors',
            }
        }
    };
</script>
